import { render, staticRenderFns } from "./PublicOverviewHostingInstitution.vue?vue&type=template&id=f7971426"
import script from "./PublicOverviewHostingInstitution.vue?vue&type=script&lang=js"
export * from "./PublicOverviewHostingInstitution.vue?vue&type=script&lang=js"
import style0 from "./PublicOverviewHostingInstitution.vue?vue&type=style&index=0&id=f7971426&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports